import React from "react";
import { Box, Skeleton } from "@mui/material";

/**
 * Skeleton building blocks.
 *
 * SkeletonRows — table-like placeholder
 * SkeletonCard — card-sized placeholder for grids
 * SkeletonStat — stat-card-sized placeholder
 */

const BG = "#e2e8f0"; // slate-200

export function SkeletonRows({ rows = 5, columns = 4 }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {Array.from({ length: rows }).map((_, r) => (
        <Box
          key={r}
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: "12px",
            alignItems: "center",
            height: 56,
            px: "12px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          {Array.from({ length: columns }).map((__, c) => (
            <Skeleton
              key={c}
              variant="rounded"
              height={14}
              width={c === columns - 1 ? "40%" : "70%"}
              animation="wave"
              sx={{ bgcolor: BG }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}

export function SkeletonCard() {
  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        p: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Skeleton variant="rounded" width="55%" height={18} animation="wave" sx={{ bgcolor: BG }} />
      <Skeleton variant="rounded" width="100%" height={14} animation="wave" sx={{ bgcolor: BG }} />
      <Skeleton variant="rounded" width="85%" height={14} animation="wave" sx={{ bgcolor: BG }} />
      <Box sx={{ display: "flex", gap: "8px", mt: "8px" }}>
        <Skeleton variant="rounded" width={80} height={28} animation="wave" sx={{ bgcolor: BG }} />
        <Skeleton variant="rounded" width={80} height={28} animation="wave" sx={{ bgcolor: BG }} />
      </Box>
    </Box>
  );
}

export function SkeletonStat() {
  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        p: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        minHeight: 120,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Skeleton variant="rounded" width={96} height={12} animation="wave" sx={{ bgcolor: BG }} />
        <Skeleton variant="rounded" width={32} height={32} animation="wave" sx={{ bgcolor: BG }} />
      </Box>
      <Skeleton variant="rounded" width="50%" height={28} animation="wave" sx={{ bgcolor: BG }} />
      <Skeleton variant="rounded" width="70%" height={12} animation="wave" sx={{ bgcolor: BG }} />
    </Box>
  );
}

const Skeletons = { SkeletonRows, SkeletonCard, SkeletonStat };
export default Skeletons;
